export default {
  'lv2':[
    'A ball goes round and round.',
    'A windmill goes round and round.',
    'The salt went in.',
    'The cheese went in.',
    'A baby cat is a kitten.',
    'A baby cow is a calf.',
    'We see sand at the beach.',
    'We see boats at the beach.',
    'Can the horses go fast?',
    'Can the birds go fast?',
    '“We are slow,” said the snails.',
    '“We are slow,” said the turtles.'
  ],
  'lv3':[
    '“Look! I have spots,” said the giraffe.',
    '“Look! I have stripes,” said the tiger.',
    'We put on our space suits.',
    'We put on our boots.',
    'My hands are good for touching.',
    'My hands are good for drawing.',
    'I see some eggs.',
    'We see some crocodiles. Snap!',
    'Come and help me with my puppy.',
    'Come and help me with my kite.',
    'He likes to get a big bone.',
    'He likes to run after cats and rabbits.'
  ],
  'lv4':[
    'It was burning fast.',
    'They were crawling faster.',
    'My mother carries me in her pouch.',
    'My father carries me on his shoulders',
    'Look! Some baby fish are coming out.',
    'Look! Some baby birds are coming out. ',
    'We saw some hungry zebras.',
    'At the zoo we saw some hungry monkeys',
    'My father likes to play sports.',
    'My little brother likes animals.',
    'Some people have straight hair.',
    'Some people have short hair.'
  ]
}



// WEBPACK FOOTER //
// ./src/testdata/read.js